import millify from 'millify';

interface Config {
  /* Number of decimal places to use */
  precision: number;
  /* Formats the number in different languages ex- de-DE */
  locales: string | Array<string>;
  /* Use lowercase abbreviations */
  lowercase: boolean;
  /* Add a space between number and abbreviation */
  space: boolean;
  /* Unit abbreviations ex- ['', 'K', 'M', 'B', 'T', 'P', 'E'] */
  units: Array<string>;
}

/**
 *
 * @param number a large number to convert  into pretty, human-readable strings
 * @param config modifiers applied to the conversion function
 * @returns a modified string based on the number and modifiers
 */
export const minifyNumber = (number: number, config: Config = undefined) => millify(number, config);
